import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.removeItem('user');
    navigate('/login'); 
  }, [navigate]);

  //return navigate('/login'); 
};

export default Logout;
